export default "__VITE_ASSET__BPAi0cAz__"